export enum CountryListType {
  ADMIN = 'ADMIN',
  USER_PROFILE = 'USER_PROFILE',
  BILLING = 'BILLING',
}
